import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

// 0 -> Felvitel
// 1 -> módosítás
let _muvelet = 0;
let _modositoObj = null;

class BanktipusLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ['QUERY', 'LOAD', 'DATA', 'NETW', 'TABL']
      currentStatusBaseTable: 'LOAD',
      modalFelvitel: false,
      modalTorles: false,
      dataLoaded: false,
      dataFailed: false,
      baseJson: [],
      aktivTipusok: [],
      aktivStatuszok: [],
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.updateTable = this.updateTable.bind(this);
  }

  componentDidMount() {
    this.updateTable();
  }

  /** Dinamikusan töltendő szűkítő feltételek lekérdezése */
  // getEnums = () => {
  //   Services.listInflacioEnums((err, res) => {
  //     if (!err) {
  //       let aktivTipusok = res[0][0].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  //       let aktivStatuszok = res[0][1].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
  //       this.setState({
  //         aktivTipusok: aktivTipusok,
  //         aktivStatuszok: aktivStatuszok
  //       });
  //     }
  //   });
  // }

  /** Objektumot bejárva az üres stringeket NULL-ra állítja */
  emptyToNull = (obj) => {
    if (!obj || typeof obj !== 'object') return;
    for (let p in obj) {
      if (typeof obj[p] === 'object' && obj[p] !== null) {
        this.emptyToNull(obj[p]);
      } else if (obj.hasOwnProperty(p)) {
        if (obj[p] === '' || obj[p] === undefined) {
          obj[p] = null;
        }
      }
    }
  }

  updateTable = () => {
    // this.getEnums();
    this.setState({
      currentStatusBaseTable: 'LOAD'
    });
    Services.listBankttipus((err, res) => {
      if (err) {
        this.setState({
          currentStatusBaseTable: 'NETW'
        });
      } else {
        this.setState({
          baseJson: res[0],
          currentStatusBaseTable: res[0].length > 0 ? 'TABL' : 'DATA'
        });
      }
    });
  }

  fillModositoObj = () => {
    this.setState({ modifyDataLoaded: false, modfiyDataFailed: false });

    Services.getBanktipus(this._currentEditId, (err, res) => {
      if (err) {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: true });
      } else {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: false });
        res[0].felhasznalva ? res[0].felhasznalva = 'true' : res[0].felhasznalva = 'false';
        _modositoObj = res[0];
        this.toggleFelvitel();
      }
    });
  }

  clearModositoObj = () => {
    _modositoObj = {
      id: '',
      ev: '',
      tipus: '',
      mertek: '',
      statusz: ''
    };
  }


  toggleFelvitel = () => {
    this.setState({ modalFelvitel: !this.state.modalFelvitel });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  handleEditClick = (id) => {
    _muvelet = 1;
    this._currentEditId = id;
    this.fillModositoObj();
  }

  handleNewClick = () => {
    _muvelet = 0;
    this.clearModositoObj();
    this.toggleFelvitel();
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        { this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell, row)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-edit-' + cell} delay={10}>
              Módosítás
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-delete-' + cell} delay={10}>
              Törlés
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  /**
  * Visszaadja az apartmanhoz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    return cell.name === 'AKTIV'
      ? <span className="badge badge-success">Aktív</span>
      : <span className="badge badge-default">Inaktív</span>;
  }

  felhasznalvaFormatter = (cell) => {
    return cell ? 'Igen' : 'Nem';
  }

  addBanktipus = (event, banktipusObj) => {
    this.emptyToNull(banktipusObj);
    this.setState({ addButtonLoading: true });
    Services.addBanktipus(banktipusObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Banktípus felvéve!');
      }
      this.setState({ addButtonLoading: false });
    });
  }

  updateBankTipus = (event, banktipusObj) => {
    banktipusObj.id = this._currentEditId;

    this.setState({ modifyButtonLoading: true });
    Services.editBanktipus(banktipusObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Banktípus módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteBanktipus = (id) => {
    this.toggleTorles();
    this.setState({ deleteButtonLoading: true });
    Services.deleteBanktipus(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Banktípus törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  filterType = (cell) => {
    // just return type for filtering or searching.
    return cell.caption;
  }

  renderBaseTable = () => {
    const pagination = true;
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
    };

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style:
         { whiteSpace: 'normal' },
      },
      {
        dataField: 'cim',
        text: 'Cím',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'szam',
        text: 'Szám',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal', width: 120 },
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter,
        hidden: !this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS'], true),
        style: { width: 100 },
      },
    ];

    return (
      <BootstrapTable
        bootstrap4
        keyField="id"
        columns={columns}
        data={this.state.baseJson}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        { this.props.globals.hasRole(['PENZUGYKOZOS_BANKTIPUS'], true) &&
          <div className="row">
            <div className="col-sm-12">
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>Új banktípus</Button>
            </div>
          </div>
        }
        {{
            QUERY: (<QueryEmptyState
              hasImage
            />),
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => this.updateTable()}
            />),
            TABL: (this.renderBaseTable())
          }[this.state.currentStatusBaseTable]}
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>
            Valóban törölni kívánod a kiválasztott tételt?
          </ModalBody>
          <ModalFooter>
            <ProgressButton className="btn-cursor-pointer" color="primary" loading={this.state.deleteButtonLoading} onClick={() => this.deleteBanktipus(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalFelvitel} toggle={this.toggleFelvitel} className={this.props.className} backdrop="static" >
          <RFForm
            modal
            onSubmit={_muvelet === 0 ? this.addBanktipus : this.updateBankTipus}
            title={_muvelet === 0 ? "Új banktípus rögzítése" : "Meglévő banktípus módosítása"}
            footer={
              <>
                <ProgressButton color="primary" loading={_muvelet === 0 ? this.state.addButtonLoading : this.state.modifyButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.toggleFelvitel} >Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Azonosító:"
              name="azonosito"
              id="azonosito"
              required
              value={_modositoObj && _modositoObj.azonosito}
              disabled={_muvelet !== 0}
            />
            <RFField
              label="Név:"
              name="nev"
              id="nev"
              required
              value={_modositoObj && _modositoObj.nev}
            />
            <RFField
              label="Cím:"
              name="cim"
              id="cim"
              required
              value={_modositoObj && _modositoObj.cim}
            />
            <RFField
              label="Szám:"
              name="szam"
              id="szam"
              required
              numberOnlyWhole
              value={_modositoObj && _modositoObj.szam}
            />
          </RFForm>
        </Modal>
      </div>
    );
  }
}

BanktipusLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object,
  className: PropTypes.string,
};

export default BanktipusLista;
